const config = document.querySelector('script[data-fumee-optional-components]');
const pending = new Map(Object.entries(JSON.parse(config?.dataset.fumeeOptionalComponents || '{}')));
const loading = new Set();

function loadFor(root) {
  for (const [selector, url] of pending) {
    if (loading.has(selector) || !(root.matches?.(selector) || root.querySelector(selector))) continue;
    loading.add(selector);
    import(url)
      .then(() => {
        pending.delete(selector);
        if (!pending.size) observer.disconnect();
      })
      .catch(error => console.error('Unable to load theme component:', selector, error))
      .finally(() => loading.delete(selector));
  }
}

const observer = new MutationObserver(records => {
  for (const record of records) {
    for (const node of record.addedNodes) {
      if (node instanceof Element) loadFor(node);
    }
  }
});
observer.observe(document.documentElement, { childList: true, subtree: true });
loadFor(document);
